{
  "actions": "Handlinger",
  "actionsAvailable": "Tilgjengelige handlinger.",
  "clearSelection": "Tøm utvalg",
  "selected": "{count, plural, =0 {Ingen er valgt} other {# er valgt}}",
  "selectedAll": "Alle er valgt"
}
